/* ELEMENTO — product grid wishlist heart.
   Rendered by snippets/product-grid-item.liquid, one button per card.
   Talks to Swym's JS API directly, so no chooser and no toast. */
(function(){
  if (window.__ebGridHeart) return;
  window.__ebGridHeart = true;

  var SEL = '.eb-grid-heart';

  // ---- suppress Swym's overlays (toast, action popup, chooser) --------
  function isSwym(el){
    if (!el || el.nodeType !== 1) return false;
    var id = el.id || '';
    var cn = typeof el.className === 'string' ? el.className : (el.getAttribute('class') || '');
    var tag = (el.tagName || '').toLowerCase();
    return /swym/i.test(id) || /swym/i.test(cn) || tag.indexOf('swym') === 0;
  }

  function suppress(el){
    if (el.getAttribute('data-eb-suppressed')) return;
    var cs;
    try { cs = window.getComputedStyle(el); } catch(e){ return; }
    if (!cs || (cs.position !== 'fixed' && cs.position !== 'sticky')) return;
    el.setAttribute('data-eb-suppressed','1');
    el.style.setProperty('display','none','important');
  }

  function killOverlays(root){
    var scope = (root && root.querySelectorAll) ? root : document;
    if (isSwym(scope)) suppress(scope);
    var nodes = scope.querySelectorAll('[class*="swym"], [id*="swym"]');
    for (var i=0;i<nodes.length;i++){ if (isSwym(nodes[i])) suppress(nodes[i]); }
  }

  function sweep(){
    killOverlays(document);
    [50,200,500,1000,1800].forEach(function(ms){ setTimeout(function(){ killOverlays(document); }, ms); });
  }

  try {
    new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){
        var added = muts[i].addedNodes;
        for (var j=0;j<added.length;j++){
          if (added[j].nodeType === 1) killOverlays(added[j]);
        }
      }
    }).observe(document.documentElement, {childList:true, subtree:true});
  } catch(e){}

  // ---- state ---------------------------------------------------------
  function payload(btn){
    return {
      empi: Number(btn.getAttribute('data-empi')),
      epi:  Number(btn.getAttribute('data-epi')),
      du:   btn.getAttribute('data-du'),
      dt:   btn.getAttribute('data-dt'),
      iu:   btn.getAttribute('data-iu'),
      pr:   parseFloat(btn.getAttribute('data-pr')) || 0,
      stk:  1
    };
  }

  function markAll(items){
    var saved = {};
    (items||[]).forEach(function(it){ if (it && it.epi != null) saved[Number(it.epi)] = 1; });
    var btns = document.querySelectorAll(SEL);
    for (var i=0;i<btns.length;i++){
      var on = !!saved[Number(btns[i].getAttribute('data-epi'))];
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function flatten(lists){
    var out = [];
    (lists||[]).forEach(function(l){
      var items = l && (l.listcontents || l.items || l.products);
      if (items && items.length) items.forEach(function(i){ out.push(i); });
      else if (l && l.epi) out.push(l);
    });
    return out;
  }

  function refresh(){
    var swat = window._swat;
    if (!swat) return;
    try {
      if (typeof swat.fetch === 'function'){ swat.fetch(function(i){ markAll(i); }, function(){}); return; }
    } catch(e){}
    try {
      if (typeof swat.retrieve === 'function'){ swat.retrieve(function(l){ markAll(flatten(l)); }, function(){}); }
    } catch(e){}
  }

  // ---- toggle --------------------------------------------------------
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var swat = window._swat;
    if (!swat) return;

    var wasOn = btn.getAttribute('aria-pressed') === 'true';
    btn.setAttribute('aria-pressed', wasOn ? 'false' : 'true');

    var done = function(){ sweep(); setTimeout(refresh, 300); };
    var p = payload(btn);

    try {
      if (wasOn){
        var remove = swat.deleteFromWishList || swat.removeFromWishList;
        if (typeof remove === 'function') remove.call(swat, p, done, done);
      } else if (typeof swat.addToWishList === 'function'){
        swat.addToWishList(p, done, done);
      }
    } catch(err){
      btn.setAttribute('aria-pressed', wasOn ? 'true' : 'false');
    }

    sweep();
  }, true);

  // ---- lifecycle -----------------------------------------------------
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function(){ refresh(); sweep(); });

  ['swym:added-to-wishlist','swym:removed-from-wishlist','swym:collections-loaded','swym:ready']
    .forEach(function(evt){ document.addEventListener(evt, function(){ sweep(); refresh(); }); });

  document.addEventListener('DOMContentLoaded', function(){ refresh(); sweep(); });
  window.addEventListener('load', function(){ refresh(); sweep(); });

  // Infinite scroll / AJAX filtering inject new cards.
  var last = 0;
  try {
    new MutationObserver(function(){
      var now = Date.now();
      if (now - last < 400) return;
      last = now;
      refresh();
    }).observe(document.documentElement, {childList:true, subtree:true});
  } catch(e){}
})();
